var pounds = true;
/*

The structure of the elements is as follows:

"Product title": "price shown in collection page",
			"Product title-Variant a": "price of variant a",
            "Product title-Variant b": "price of variant b",
            ...
            ...
            ...
            "Variant x": "price of variant x",
            
If the product has only 1 variant, you don"t need to add it
to the list, the code will automatically take the price shown
on the collection page and show it as the product price.

Here are some examples:

Add a product "Blue color" with no variants:
"Blue color": "77.18",

Add a product "Blue color" with 2 variants(Rod and Fine Frit):
"Blue color": "77.18",
			"Blue color-Rod": "77.18",
			"Blue color-Fine Frint": "52.07",
            
Rules:
1.- For variants, the structure of the entry is as follows:
		"Product title-Variant a": "price fo variant a",
1.- For variants, there should not be blank spaces right after or right before the "-".
2.- For variants and product titles, the name must be EXACTLY the same that the names
from shopify (case sensitive).
3.- For variants and products, every entry on the list must be "," separated.


*/
var prices = {

//COLORS: *************************************************************************************
//North Star Glass
    "Alien Tech": "95.00",
			"Alien Tech-Rod": "95.00",	
  			"Alien Tech-Odds": "27.25",
    "Alaskan Thunder": "59.00",
            "Alaskan Thunder-Rod": "59.00",
            "Alaskan Thunder-Powder": "45.40",
	"Amber Purple": "63.50",
            "Amber Purple-Rod": "63.50",
            "Amber Purple-Fine Frit": "59.00",
            "Amber Purple-Large Frit": "63.50",
    "Aurora": "68.00",
            "Aurora-Rod": "68.00",
            "Aurora-Fine Frit": "68.00",
            "Aurora-Large Frit": "68.00",
    "Black Lightning": "59.00",
			"Black Lightning-Rod": "59.00",
	"Blue Caramel": "77.00",
			"Blue Caramel-Rod": "77.00",
  			"Blue Caramel-Small Frit": "68.00",
            "Blue Caramel-Fine Frit": "68.00",
	"Blue Exotic": "81.50",
			"Blue Exotic-Rod": "81.50",
			"Blue Exotic-Fine Frit": "63.50",
            "Blue Exotic-Seconds": "27.25",
	"Blue Moon": "59.00",
			"Blue Moon-Rod": "59.00",
			"Blue Moon-Large Frit": "59.00",
			"Blue Moon-Small Frit": "59.00",
			"Blue Moon-Fine Frit": "59.00",
			"Blue Moon-Powder": "63.50",
    "Berry Gumbolt": "49.95",
			"Berry Gumbolt-Rod": "49.95",
			"Berry Gumbolt-Large Frit": "54.50",
			"Berry Gumbolt-Small Frit": "54.50",
			"Berry Gumbolt-Fine Frit": "54.50",
			"Berry Gumbolt-Powder": "59.00",
    "Blue Thunder": "49.95",
    "Brillo": "63.50",
    "Blue Spruce": "63.50",
			"Blue Spruce-Rod": "63.50",
			"Blue Spruce-Large Frit": "63.50",
			"Blue Spruce-Small Frit": "63.50",
			"Blue Spruce-Fine Frit": "63.50",
			"Blue Spruce-Powder": "68.00",
    "Bubblegum": "81.50",
			"Bubblegum-Rod": "81.50",
			"Bubblegum-Large Frit": "68.00",
			"Bubblegum-Small Frit": "68.00",
			"Bubblegum-Fine Frit": "68.00",
			"Bubblegum-Powder": "77.00",
	"Blue-Green": "54.50",
			"Blue-Green-Rod": "54.50",
			"Blue-Green-Large Frit": "59.00",
			"Blue-Green-Fine Frit": "59.00",
	"Butterscotch": "63.50",
            "Butterscotch-Rod": "63.50",
            "Butterscotch-Fine Frit": "59.00",
            "Butterscoth-Large Frit": "59.00",
	"Canary": "63.50",
			"Canary-Rod": "63.50",
			"Canary-Small Frit": "63.50",
            "Canary-Fine Frit": "63.50",
	"Caramel": "63.50",
			"Caramel-Rod": "63.50",
			"Caramel-Large Frit": "63.50",
			"Caramel-Small Frit": "63.50",
			"Caramel-Fine Frit": "63.50",
	"Cherry": "63.50",
			"Cherry-Rod": "63.50",
			"Cherry-Small Frit": "63.50",
            "Cherry-Fine Frit": "63.50",
            "Cherry-Large Frit": "63.50",
	"Cobalt Blue": "40.85",
            "Cobalt Blue-Rod": "40.85",
			"Cobalt Blue-Cobalt 2nds": "22.75",
            "Cobalt Blue-Fine Frit": "45.40",
	"Crystal Bliss": "49.95",
            "Crystal Bliss-Rod": "49.95",
            "Crystal Bliss-Large Frit": "54.50",
            "Crystal Bliss-Fine Frit": "49.95",
            "Crystal Bliss-Seconds": "30.00",
	"Dark Garnet": "63.50",
			"Dark Garnet-Rod": "63.50",
			"Dark Garnet-Large Frit": "59.00",
			"Dark Garnet-Fine Frit": "59.00",
            "Dark Garnet-Small Frit": "59.00",
	"Dark Multi": "59.00",
    "Dark Ruby": "63.50",
    "Dark Amethyst": "49.95",
    "Dark Cobalt": "40.85",
            "Dark Cobalt-Rod": "40.85",
			"Dark Cobalt-Large Frit": "45.40",
			"Dark Cobalt-Fine Frit": "45.40",
    "Dark Orange": "63.50",
			"Dark Orange-Rod": "63.50",
			"Dark Orange-Large Frit": "54.50",
			"Dark Orange-Small Frit": "54.50",
			"Dark Orange-Fine Frit": "54.50",
			"Dark Orange-Powder": "59.00",
    "Dark Blue Amber/Purple": "63.50",
	"Deep Sea Blue": "49.95",
			"Deep Sea Blue-Rod": "49.95",
			"Deep Sea Blue-Large Frit": "59.00",
	"Double Amber Purple": "63.50",
			"Double Amber Purple-Rod": "63.50",
			"Double Amber Purple-Large Frit": "63.50",
	"Egyptian White Sand": "68.00",
			"Egyptian White Sand-Rod": "68.00",
			"Egyptian White Sand-Large Frit": "59.00",
			"Egyptian White Sand-Small Frit": "59.00",
			"Egyptian White Sand-Fine Frit": "59.00",
			"Egyptian White Sand-Powder": "68.00",
	"English Ivy": "59.00",
	"Evergreen": "68.00",
			"Evergreen-Rod": "68.00",
			"Evergreen-Large Frit": "68.00",
			"Evergreen-Small Frit": "68.00",
	"EXP Green #5": "72.50",
			"EXP Green #5-Rod": "72.50",
			"EXP Green #5-Small Frit": "72.50",
			"EXP Green #5-Fine Frit": "72.50",
	"Extra Light Yellow": "49.95",
	"Forest Green": "68.00",
			"Forest Green-Rod": "68.00",
			"Forest Green-Large Frit": "68.00",
			"Forest Green-Small Frit": "68.00",
			"Forest Green-Fine Frit": "68.00",
			"Forest Green-Powder": "72.50",
	"Garnet": "63.50",
	"Glacier Blue": "54.50",
    "Gemini": "72.50",
			"Gemini-Rod": "72.50",
			"Gemini-Large Frit": "45.40",
			"Gemini-Small Frit": "45.40",
			"Gemini-Fine Frit": "45.40",
	"Goldenrod": "68.00",
            "Goldenrod-Rod": "68.00",
			"Goldenrod-Large Frit": "68.00",
			"Goldenrod-Small Frit": "68.00",
			"Goldenrod-Fine Frit": "68.00",
			"Goldenrod-Powder": "68.00",
	"Green Amber/Purple": "77.00",
			"Green Amber/Purple-Rod": "77.00",
			"Green Amber/Purple-Large Frit": "77.00",
			"Green Amber/Purple-Small Frit": "77.00",
			"Green Amber/Purple-Fine Frit": "77.00",
			"Green Amber/Purple-Powder": "77.00",
	"Green Exotic": "72.50",
            "Green Exotic-Rod": "72.50",
            "Green Exotic-Fine Frit": "63.50",
   	"Hyacinth": "59.00",
	"Ice Blue": "54.50",
	"Illuminati": "99.85",
            "Illuminati-Rod 1st": "99.85",
            "Illuminati-Rod 2nds": "63.50",
            "Illuminati-Fine Frit": "108.95",
            "Illuminati-Small Frit": "108.95",
	"Indigo Aventurine": "59.00",
	"Irrid": "59.00",
			"Irrid-Rod": "59.00",
			"Irrid-Large Frit": "59.00",
			"Irrid-Small Frit": "59.00",
			"Irrid-Fine Frit": "59.00",
			"Irrid-Powder": "59.00",
	"Jade": "68.00",
			"Jade-Rod": "68.00",
            "Jade-Large Frit": "63.50",
            "Jade-Fine Frit": "63.50",
			"Jade-Small Frit": "68.00",
	"Jet Black": "54.50",
			"Jet Black-Rod": "31.75",
			"Jet Black-Large Frit": "54.50",
            "Jet Black-Small Frit": "54.50",
            "Jet Black-Fine Frit": "54.50",
			"Jet Black-Powder": "59.00",
	"Lava": "63.50",
            "Lava-Rod": "63.50",
            "Lava-Small Frit": "63.50",
            "Lava-Fine Frit": "63.50",
	"Lavender": "77.00",
	"Light Blue Amber Purple": "59.00",
	"Light Cobalt": "40.85",
	"Light Oregon Gray": "63.50",
	"Light Ruby": "54.50",
	"Loch Ness": "68.00",
			"Loch Ness-Rod": "68.00",
			"Loch Ness-Small Frit": "68.00",
			"Loch Ness-Fine Frit": "68.00",
			"Loch Ness-Powder": "68.00",
            "Loch Ness-Seconds": "31.75",
	"Lokis Lipstick": "63.50",
	"Midnight": "68.00",
			"Midnight-Rod 1st": "68.00",
            "Midnight-Rod 2nds": "22.50",
			"Midnight-Large Frit": "68.00",
			"Midnight-Small Frit": "68.00",
			"Midnight-Fine Frit": "68.00",
			"Midnight-Powder": "72.50",
	"Millennium Moss": "68.00",
            "Millennium Moss-Rod 2nds": "22.70",
			"Millennium Moss-Rod First": "68.00",
	"Mint": "59.00",
	"Multi": "59.00",
	"Mystery Aventurine": "63.50",
			"Mystery Aventurine-Rod": "63.50",
			"Mystery Aventurine-Large Frit": "63.50",
			"Mystery Aventurine-Small Frit": "63.50",
            "Mystery Aventurine-Fine Frit": "63.50",
	"Nile": "90.80",
	"Ninja": "68.00",
	"Onyx": "54.50",
			"Onyx-Rod": "31.75",
			"Onyx-Large Frit": "59.00",
	"Opaque Aqua": "49.95",
	"Orange": "72.50",
	"Oregon Gray": "63.50",
	"Persephone": "49.95",
			"Persephone-Rod": "49.95",
			"Persephone-Large Frit": "45.40",
			"Persephone-Fine Frit": "45.40",
    "Peach": "118.00",
	"Periwinkle": "59.00",
			"Periwinkle-Rod": "59.00",
			"Periwinkle-Large Frit": "59.00",
	"Pink": "77.00",
	"Plum Krazy": "68.00",
            "Plum Krazy-Rod": "68.00",
            "Plum Krazy-Fine Frit": "63.50",
	"Plum Kush": "63.50",
			"Plum Kush-Rod": "63.50",
			"Plum Kush-Fine Frit": "59.00",
            "Plum Kush-Small Frit": "63.50",
            "Plum Kush-Large Frit": "63.50",
	"Pomegranate": "63.50",
			"Pomegranate-Rod First": "63.50",
			"Pomegranate-2nd's": "31.25",
  			"Pomegranate-Odds": "45.35",
	"Poppy": "68.00",
	"Purple Lillac": "81.50",
	"Purple Urple": "63.50",
			"Purple Urple-Rod": "63.50",
			"Purple Urple-Large Frit": "59.00",
			"Purple Urple-Small Frit": "59.00",
			"Purple Urple-Fine Frit": "59.00",
			"Purple Urple-Powder": "68.00",
	"Red Exotic": "72.50",
	"Rootbeer": "68.00",
            "Rootbeer-Rod 1st": "68.00",
            "Rootbeer-Rod 2nds": "36.25",
    "Roswell": "72.50",
  			"Roswell-2nds": "36.25",
	"Ruby": "63.50",
			"Ruby-Rod": "63.50",
			"Ruby-Large Frit": "59.00",
			"Ruby-Small Frit": "59.00",
			"Ruby-Fine Frit": "59.00",
			"Ruby-Powder": "68.00",
	"Rust": "59.00",
			"Rust-Rod": "59.00",
			"Rust-Large Frit": "59.00",
			"Rust-Small Frit": "59.00",
			"Rust-Fine Frit": "59.00",
			"Rust-Powder": "59.00",
	"Silver Amethyst": "54.50",
	"Silver Aqua": "68.00",
	"Silver Bullet": "54.50",
            "Silver Bullet-2nd's": "27.25",
            "Silver Bullet-Rod 1st": "54.50",
	"Silver Creek": "54.50",
            "Silver Creek-Rod": "54.50",
            "Silver Creek-Fine Frit": "54.50",
            "Silver Creek-Frit Small": "54.50",
	"Silver Sea Weed": "63.50",
	"Silver Unobtainium": "68.00",
			"Silver Unobtainium-Rod": "68.00",
			"Silver Unobtainium-Large Frit": "68.00",
			"Silver Unobtainium-Small Frit": "68.00",
			"Silver Unobtainium-Fine Frit": "68.00",
			"Silver Unobtainium-Powder": "72.50",
	"Skyline": "63.50",
			"Skyline-Rod": "63.50",
			"Skyline-Large Frit": "59.00",
	"Star White": "31.75",
			"Star White-Rod First": "54.50",
            "Star White-Rod Odds": "36.25",
			"Star White-Large Frit": "68.00",
            "Star White-Small Frit": "68.00",
            "Star White-Fine Frit": "68.00",
			"Star White-Powder": "72.50", 
            "Star White-Seconds": "22.50",
	"Steel Wool": "63.50",
	"Sublime": "77.00",
	"Super Unobtainium": "68.00",
            "Super Unobtainium-Rod": "68.00",
            "Super Unobtainium-Large Frit": "63.50",
	"Tan Silver Creek": "54.50",
 	 "Timber": "63.50",
	"Transparent Green": "86.25",
			"Transparent Green-Rod": "86.25",
			"Transparent Green-Large Frit": "54.50",
			"Transparent Green-Small Frit": "54.50",
			"Transparent Green-Fine Frit": "54.50",
			"Transparent Green-Powder": "59.00",
            "Transparent Green-Rod 2nd": "22.75",
	"Turbo Amethyst": "54.50",
			"Turbo Amethyst-Rod": "54.50",
			"Turbo Amethyst-Large Frit": "54.50",
			"Turbo Amethyst-Small Frit": "54.50",
			"Turbo Amethyst-Fine Frit": "54.50",
			"Turbo Amethyst-Powder": "59.00",
	"Turbo Cobalt": "40.85",
	"Turquesa": "54.50",
	"Unobtainium": "68.00",
			"Unobtainium-Rod": "68.00",
            "Unobtainium-Large Frit": "68.00",
			"Unobtainium-Small Frit": "68.00",
			"Unobtainium-Fine Frit": "68.00",
	"Violet": "77.00",
	"Yellow": "54.50",
			"Yellow-Rod": "54.50",
			"Yellow-Small Frit": "54.50",
            "Yellow-Fine Frit": "54.50",
    "Lucy": "81.50",
			"Lucy-Rod First": "81.50",
			"Lucy-Rod Seconds": "36.25",
			"Lucy-Rod Odds": "54.50",
  			"Lucy-Small Frit": "81.50",
  			"Lucy-Large Frit": "81.50",
    "Blue Spruce": "63.50",
            "Blue Spruce-Rod": "63.50",
    "Mauvelous": "59.00",
            "Mauvelous-Rod": "59.00",
    "Ursa": "59.00",
            "Ursa-Rod": "59.02",
    "Absinthe": "72.50",
            "Absinthe-Rod": "72.50",
    "Maple Syrup": "59.00",
            "Maple Syrup-Rod First": "59.00",
            "Maple Syrup-Rod Odds": "22.50",
    "Grizzly": "63.50",
            "Grizzly-Rod": "63.50",
    "Luna": "77.00",
            "Luna-Rod": "77.00",
    "Nova": "81.50",
            "Nova-Rod": "81.50",
    "Siriusly": "77.00",
            "Siriusly-Rod": "77.00",
    "Hydra": "77.00",
            "Hydra-Rod First": "77.00",
  "Nemo": "68.00",
  "Coma": "68.00",
			
//TAG Glass
	"Apricot": "54.50",
	"Black Jack": "59.00",
	"Caramelo": "59.00",
	"Dark Red (Black) Elvis": "59.00",
			"Dark Red (Black) Elvis-Rod": "59.00",
			"Dark Red (Black) Elvis-Fine Frit": "72.50",
	"Darth Badger": "72.50",
	"Dense Slyme": "99.85",
	"Double Mai Tai": "63.50",
	"Green X": "54.50",
    "Green Stardust": "59.00",
	"Heavy Blue Leprechaun": "99.85",
	"Heavy Blue Stardust": "63.50",
	"Heavy Teal": "99.85",
  	"Heavy Xenon": "99.85",
	"Honey Badger": "63.50",
	"IO Star": "63.50",
	"Leprechaun": "59.00",
	"Mighty Moss": "99.85",
			"Mighty Moss-Rod": "99.85",
			"Mighty Moss-Fine Frit": "99.85",
	"Knight Rider": "59.00",
	"Orange Elvis": "68.00",
	"Penumbra": "59.00",
	"Pink Cadillac": "99.85",
			"Pink Cadillac-Rod": "99.85",
			"Pink Cadillac-Coarse": "131.50",
            "Pink Cadillac-Fine": "131.50",
	"Pink Lollypop": "63.50",
	"Pink Mai Tai": "54.50",
	"Pink Slyme": "99.85",
	"Purple Lollypop": "63.50",
	"Purple Sable": "63.50",
	"Queen Bee": "59.00",
	"Red Elvis": "59.00",
	"Satin Slyme": "113.50",
	"Shooting Star": "59.00",
	"Slyme": "99.85",
	"Whiteout": "72.50",
			"Whiteout-Rod": "72.50",
			"Whiteout-Medium Frit": "72.50",
			"Whiteout-Fine Frit": "72.50",
	"Wisteria": "99.85",
            "Wisteria-Rod": "99.85",
            "Wisteria-Medium Frit": "86.25",
            "Wisteria-Fine Frit": "86.25",
	"Yellow Elvis": "50.00",  
    "Light Red Elvis": "50.00",
    "Kiwi": "99.85",
  	"Sasha's Oil Slick": "68.00",
            "Sasha's Oil Slick-Rod": "68.00",
    "Blue Slyme": "68.00",
    "Mega Mai Tai": "63.50",
            "Mega Mai Tai-Rod": "63.50",
    "Blue Stardust": "59.00",
            "Blue Stardust-Rod": "59.00",
    "Atomic Stardust": "86.25",
    "Blue V": "54.50",
    "Dark Blue Slyme": "68.00",
    "Fade to Black": "86.25",
    "Pink Proton": "68.00",
    "Sea Sylme": "68.00",
    "Syzygy": "63.50",
    "Tropical Green": "63.50",
    "Solar Flare": "81.50",
    "Sunset Slyme": "77.00",
    "Parallax": "68.00",
    "Lemon Slyme": "77.00",
  	"Pink/Ivory CFL EXP 925": "77.00",
  	"Phaze": "81.50",
 	"Light Blue Stardust": "54.50",
  	"Secret White": "81.50",
 	"EXP 931 Blue Stardust CFL": "81.50",
        

//Paramore
	"Paramore Blue": "59.00",
	"Paramore Butter": "40.00",
	"Paramore Mint": "59.00",
	"Paramore New Blue": "59.00",
	"Paramore Taupe": "59.00",
	"Paramore VW": "59.00",
	"Paramore White": "59.00",
    "Paramore Pink": "59.00",
    "Paramore Siberia": "40.00",
    "Paramore Peach": "59.00",
  "Paramore Aqua": "59.00",
  "Paramore Denim": "40.85",
  "Paramore Old Gold": "40.85",
  "Paramore Paralatte": "59.00",

//Glass Alchemy
    "Red Crayon, 104": "65.00",
            "Red Crayon, 104-7mm Rod": "63.50",
			"Red Crayon, 104-4mm Rod": "72.50",
			"Red Crayon, 104-70 Grade Frit": "80.00",
            "Red Crayon, 104-38 Grade Frit": "80.00",
    "Lipstick Red, 105": "63.50",
            "Lipstick, 105 Red-7mm Rod": "63.50",
	"Sangria, 106": "63.50",
            "Sangria, 106-7mm Rod": "63.50",
    "Rozay, 1692": "90.50",
            "Rozay, 1692-7mm Rod": "90.50",
    "Half Blood, 1933": "63.50",
            "Half Blood, 1933-7mm Rod": "63.50",
    "Dragon's Blood, 1939": "63.50",
            "Dragon's Blood, 1939-7mm Rod": "63.50",
			"Dragon's Blood, 1939-4mm Rod": "72.50",
			"Dragon's Blood, 1939-Medium Frit": "77.00",
            "Dragon's Blood, 1939-Small Frit": "77.00",
    "Sunburst Orange, 202": "63.50",
            "Sunburst Orange, 202-7mm Rod": "63.50",
    "Orange Crayon, 204": "63.50",
            "Orange Crayon, 204-7mm Rod": "63.50",
			"Orange Crayon, 204-4mm Rod": "72.50",
			"Orange Crayon, 204-70 Grade Frit": "77.00",
            "Orange Crayon, 204-38 Grade Frit": "77.00",
    "Orange-Red Crayon, 208": "63.50",
            "Orange-Red Crayon, 208-7mm Rod": "63.50",
    "Tequila Sunrise, 2380": "63.50",
            "Tequila Sunrise, 2380-7mm Rod": "63.50",
    "Persimmon Strike, 2383": "63.50",
            "Persimmon Strike, 2383-7mm Rod": "63.50",
			"Persimmon Strike, 2383-4mm Rod": "72.50",
			"Persimmon Strike, 2383-70 Grade Frit": "77.00",
            "Persimmon Strike, 2383-38 Grade Frit": "77.00",
    "Amazon Bronze, 287": "63.50",
            "Amazon Bronze, 287-7mm Rod": "63.50",
			"Amazon Bronze, 287-70 Grade Frit": "77.00",
            "Amazon Bronze, 287-38 Grade Frit": "77.00",
    "Acid Yellow Crayon, 301": "63.50",
            "Acid Yellow Crayon, 301-7mm Rod": "63.50",
    "Rasta Gold Crayon, 302": "63.50",
            "Rasta Gold Crayon, 302-7mm Rod": "63.50",
			"Rasta Gold Crayon, 302-4mm Rod": "72.50",
			"Rasta Gold Crayon, 302-70 Grade Frit": "80.00",
            "Rasta Gold Crayon, 302-38 Grade Frit": "80.00",
    "Yellow Crayon, 304": "63.50",
            "Yellow Crayon, 304-7mm Rod": "63.56",
			"Yellow Crayon, 304-4mm Rod": "72.64",
			"Yellow Crayon, 304-70 Grade Frit": "80.00",
            "Yellow Crayon, 304-38 Grade Frit": "80.00",
    "Lemon Drop, 3090": "45.00",
            "Lemon Drop, 3090-7mm Rod": "45.00",
    "Singular Passion, 380": "63.50",
            "Singular Passion, 380-7mm Rod": "63.50",
    "Silver Strike-5, 385": "63.50",
            "Silver Strike-5, 385-7mm Rod": "63.50",
			"Silver Strike-5, 385-4mm Rod": "72.50",
			"Silver Strike-5, 385-Medium Frit": "77.00",
            "Silver Strike-5, 385-Small Frit": "77.00",
    "Brilliant Blue, 592": "63.50",
            "Brilliant Blue, 592-7mm Rod": "63.50",
			"Brilliant Blue, 592-4mm Rod": "72.50",
    "Chartreuse Crayon, 403": "63.50",
            "Chartreuse Crayon, 403-7mm Rod": "63.50",
    "Olive Green Crayon, 406": "63.50",
            "Olive Green Crayon, 406-7mm Rod": "63.50",
    "Alchemy Mint, 441": "59.00",
            "Alchemy Mint, 441-7mm Rod": "59.00",
			"Alchemy Mint, 441-Large Frit": "70.00",
            "Alchemy Mint, 441-Medium Frit": "70.00",
            "Alchemy Mint, 441-Small Frit": "70.00",
            "Alchemy Mint, 441-Extra Fine Frit": "70.00",
    "Agua Mist, 443": "59.00",
            "Agua Mist, 443-7mm Rod": "59.00",
    "Turquoise, 445": "59.00",
            "Turquoise, 445-7mm Rod": "59.00",
    "Agua Azul, 446": "59.00",
            "Agua Azul, 446-7mm Rod": "59.00",
			"Agua Azul, 446-4mm Rod": "68.00",
			"Agua Azul, 446-70 Grade Frit": "68.00",
            "Agua Azul, 446-38 Grade Frit": "68.00",
    "Shamrock, 4494": "63.50",
            "Shamrock, 4494-7mm Rod": "63.50",
			"Shamrock, 4494-4mm Rod": "72.50",
			"Shamrock, 4494-70 Grade Frit": "77.00",
            "Shamrock, 4494-38 Grade Frit": "77.00",
    "Tree Hugger, 4497": "63.50",
            "Tree Hugger, 4497-7mm Rod": "63.50",
			"Tree Hugger, 4497-4mm Rod": "72.50",
    "Starry Night, 4585": "63.50",
            "Starry Night, 4585-7mm Rod": "63.50",
    "Paparazzi, 4595": "63.50",
            "Paparazzi, 4595-7mm Rod": "63.50",
			"Paparazzi, 4595-4mm Rod": "72.50",
			"Paparazzi, 4595-70 Grade Frit": "77.00",
            "Paparazzi, 4595-38 Grade Frit": "77.00",
    "Jackpot, 4598": "63.50",
            "Jackpot, 4598-7mm Rod": "63.50",
			"Jackpot, 4598-4mm Rod": "72.50",
			"Jackpot, 4598-70 Grade Frit": "77.00",
            "Jackpot, 4598-38 Grade Frit": "77.00",
    "Kryptonite, 461": "45.00",
            "Kryptonite, 461-7mm Rod": "45.00",
    "Haterade, 4693": "45.00",
            "Haterade, 4693-7mm Rod": "45.00",
    "Dragon's Eye, 4838": "63.50",
            "Dragon's Eye, 4838-7mm Rod": "63.50",
			"Dragon's Eye, 4838-4mm Rod": "72.50",
			"Dragon's Eye, 4838-Medium Frit": "80.00",
            "Dragon's Eye, 4838-Small Frit": "80.00",
    "Aquatic Carnival, 489": "63.50",
            "Aquatic Carnival, 489-7mm Rod": "63.50",
			"Aquatic Carnival, 489-70 Grade Frit": "77.00",
            "Aquatic Carnival, 489-38 Grade Frit": "77.00",
    "Cobalt Lite, 510": "45.50",
            "Cobalt Lite, 510-7mm Rod": "45.50",
    "Cobalt-1, 511": "45.50",
            "Cobalt-1, 511-7mm Rod": "45.50",
    "Cobalt-4, 514": "45.50",
            "Cobalt-4, 514-7mm Rod": "45.50",
    "Cobalt-5, 515": "45.50",
            "Cobalt-5, 515-7mm Rod": "45.50",
			"Cobalt-5, 515-4mm Rod": "54.50",
			"Cobalt-5, 515-70 Grade Frit": "59.00",
            "Cobalt-5, 515-38 Grade Frit": "59.00",
    "Cobalt-6, 516": "45.50",
            "Cobalt-6, 516-7mm Rod": "45.50",
    "Bibidibobidiblue, 5192": "59.00",
            "Bibidibobidiblue, 5192-7mm Rod": "59.00",
			"Bibidibobidiblue, 5192-4mm Rod": "68.00",
			"Bibidibobidiblue, 5192-70 Grade Frit": "68.00",
            "Bibidibobidiblue, 5192-38 Grade Frit": "68.00",
    "Iris, 5194": "59.00",
            "Iris, 5194-7mm Rod": "59.00",
			"Iris, 5194-4mm Rod": "68.00",
			"Iris, 5194-70 Grade Frit": "68.00",
            "Iris, 5194-38 Grade Frit": "68.00",
    "Lapis, 5195": "59.00",
            "Lapis, 5195-7mm Rod": "59.00",
			"Lapis, 5195-4mm Rod": "68.00",
			"Lapis, 5195-70 Grade Frit": "68.00",
            "Lapis, 5195-38 Grade Frit": "68.00",
    "Really Teally, 544": "59.00",
            "Really Teally, 544-7mm Rod": "59.00",
			"Really Teally, 544-4mm Rod": "68.00",
			"Really Teally, 544-70 Grade Frit": "68.00",
            "Really Teally, 544-38 Grade Frit": "68.00",
    "Peacock, 546": "59.00",
            "Peacock, 546-7mm Rod": "59.00",
			"Peacock, 546-4mm Rod": "68.00",
			"Peacock, 546-Medium Frit": "68.00",
            "Peacock, 546-Small Frit": "68.00",
    "Twilight, 548": "59.00",
            "Twilight, 548-7mm Rod": "59.00",
			"Twilight, 548-4mm Rod": "68.00",
			"Twilight, 548-Medium Frit": "68.00",
            "Twilight, 548-Small Frit": "68.00",
    "Peacock Chameleon, 5486": "63.50",
            "Peacock Chameleon, 5486-7mm Rod": "63.50",
			"Peacock Chameleon, 5486-70 Grade Frit": "77.00",
            "Peacock Chameleon, 5486-38 Grade Frit": "77.00",
    "Sapphire, 5595": "63.50",
            "Sapphire, 5595-7mm Rod": "63.50",
    "Amazon Lagoon, 587": "63.50",
            "Amazon Lagoon, 587-7mm Rod": "63.50",
            "Amazon Lagoon, 587-4mm Rod": "77.00",
			"Amazon Lagoon, 587-70 Grade Frit": "77.00",
            "Amazon Lagoon, 587-38 Grade Frit": "77.00",
    "Blue Dream, 591": "59.00",
            "Blue Dream, 591-7mm Rod": "59.00",
    "Rain Drop, 590": "80.00",
            "Rain Drop, 590-7mm Rod": "80.00",
    "Andromeda, 6585": "63.50",
            "Andromeda, 6585-7mm Rod": "63.50",
			"Andromeda, 6585-4mm Rod": "72.50",
			"Andromeda, 6585-70 Grade Frit": "77.00",
            "Andromeda, 6585-38 Grade Frit": "77.00",
    "Purple Rain, 7692": "99.85",
            "Purple Rain, 7692-7mm Rod": "99.85",
    "Grape, 773": "59.00",
            "Grape, 773-7mm Rod": "59.00",
    "Double Passion, 783": "63.50",
            "Double Passion, 783-7mm Rod": "63.50",
			"Double Passion, 783-70 Grade Frit": "77.00",
            "Double Passion, 783-38 Grade Frit": "77.00",
    "Triple Passion, 786": "63.50",
            "Triple Passion, 786-7mm Rod": "63.50",
			"Triple Passion, 786-4mm Rod": "72.50",
			"Triple Passion, 786-Medium Frit": "77.00",
            "Triple Passion, 786-Small Frit": "77.00",
    "Passion Extreme, 788": "63.50",
            "Passion Extreme, 788-7mm Rod": "63.50",
    "Chocolate Crayon, 804": "63.50",
            "Chocolate Crayon, 804-7mm Rod": "63.50",
			"Chocolate Crayon, 804-4mm Rod": "72.50",
            "Chocolate Crayon, 804-Large Frit": "77.00",
            "Chocolate Crayon, 804-Medium Frit": "77.00",
            "Chocolate Crayon, 804-Small Frit": "77.00",
            "Chocolate Crayon, 804-Extra Fine Frit": "77.00",
    "Beryl, 833": "59.00",
            "Beryl, 833-7mm Rod": "59.00",
    "Walnut, 8475": "59.00",
            "Walnut, 8475-7mm Rod": "59.00",
    "Tiger's Eye, 8595": "63.50",
            "Tiger's Eye, 8475-7mm Rod": "63.50",
    "Sienna Brown, 864": "86.25",
            "Sienna Brown, 864-7mm Rod": "86.25",
    "Black Violet, 974": "59.00",
            "Black Violet, 974-7mm Rod": "59.00",
			"Black Violet, 974-4mm Rod": "68.00",
			"Black Violet, 974-70 Grade Frit": "68.00",
            "Black Violet, 974-38 Grade Frit": "68.00",
    "Raven, 9749": "59.00",
            "Raven, 9749-7mm Rod": "59.00",
			"Raven, 9749-4mm Rod": "68.00",
			"Raven, 9749-Medium Frit": "68.00",
            "Raven, 9749-Small Frit": "68.00",
    "Amazon Night, 987": "63.50",
            "Amazon Night, 987-7mm Rod": "63.50",
			"Amazon Night, 987-4mm Rod": "72.50",
			"Amazon Night, 987-Large Frit": "77.00",
            "Amazon Night, 987-Medium Frit": "77.00",
            "Amazon Night, 987-Small Frit": "77.00",
            "Amazon Night, 987-Extra Fine Frit": "77.00",
    "Disco Sparkle, 9958": "59.00",
            "Disco Sparkle, 9958-7mm Rod": "59.00",
    "Eclipse, 9977": "59.00",
            "Eclipse, 9977-7mm Rod": "59.00",
			"Eclipse, 9977-4mm Rod": "68.00",
    "Portland Gray, 9992": "59.00",
            "Portland Gray, 9992-7mm Rod": "59.00",
			"Portland Gray, 9992-4mm Rod": "68.00",
			"Portland Gray, 9992-70 Grade Frit": "68.00",
            "Portland Gray, 9992-38 Grade Frit": "68.00",
    "Snow White, 9995": "63.50",
            "Snow White, 9995-7mm Rod": "63.00",
			"Snow White, 9995-4mm Rod": "72.50",
			"Snow White, 9995-Medium Frit": "77.00",
            "Snow White, 9995-Small Frit": "77.00",
    "Purple Luster, 386": "63.50",
            "Purple Luster, 386-7mm Rod": "63.50",
			"Purple Luster, 386-4mm Rod": "68.00",
			"Purple Luster, 386-70 Grade Frit": "77.00",
            "Purple Luster, 386-38 Grade Frit": "77.00",
    "Rain Drop, 590": "77.00",
            "Rain Drop, 590-7mm Rod": "77.00",
    "Clear Frit": "31.75",
            "Clear Frit-70 Grade Frit": "31.75",
            "Clear Frit-38 Grade Frit": "31.75",
  	"Antidote": "81.50",
  	"Serum": "81.50",
  	"Pastel Serum": "81.50",
  	"Brozay": "90.00",
  	"Crippy": "81.50",
  	"Terps - Neo- Cad": "81.50",
  	"Citron - Neo- Cad": "55.00",
  	"Ether": "81.50",
  	"Hot Sauce": "59.00",
  "Blue Dream": "59.00",
  "Purple Rain": "99.85",
  "Potion": "81.50",
  "Rozay": "90.50",
  "Electric Flamingo": "81.50",
  "Kryptonite 2002, 4629": "45.00",
  "Ultramarine": "45.00",
  "Elixir": "45.00",

//South Florida Glass
  "Blue South Florida UV Glass": "99.88",
            "South Florida UV Glass-7mm Rod": "99.88",
            "South Florida UV Glass-Rod Odds": "77.18",
  "Peach South Florida UV Glass": "99.88",
            "South Florida UV Glass-7mm Rod": "99.88",
            "South Florida UV Glass-Rod Odds": "77.18",
  
//UV Glass

//Momka Glass
  
//Grease Glass Rod
  "Blue Cheese": "68.00",
            "Blue Cheese-Rod": "68.00",
  "Globalt Rod": "72.50",
            "Globalt Rod-Rod": "72.50",
  "Hulk CFL Rod": "149.50",
            "Hulk CFL Rod-Rod": "149.50",
  "Purple Rainbow Rod": "81.50",
            "Purple Rainbow Rod Rod-Rod": "81.50",
  "Yoshi CFL Rod": "122.50",
            "Yoshi CFL Rod Rod-Rod": "122.50",
  "Blue/Purple Cheese": "68.00",
    
  
  
  
  
//TUBING AND ROD: ****************************************************************************
//Trautman Hand Pulled Tubing
	"Dark Red Elvis Tubing": "77.00",
	"Double Mai Tai Tubing": "77.00",
	"Might Moss Tubing": "77.00",
			"Might Moss Tubing-First": "77.00",
			"Might Moss Tubing-Seconds": "59.00",
	"Purple Lollipop Tubing": "77.00",
	"Shooting Star Tubing": "77.00",
	"White Out Tubing": "77.00",
	"Wisteria Tubing": "77.00",
    "Darth Badger Tubing": "77.00",
    "Pink Cadillac Tubing": "77.00",
    "Pink  Proton Tubing": "99.85",
    "Blue V Tubing": "108.95",
    "Syzygy Tubing": "104.50",
    "Blue Slyme Tubing": "90.80",
    "Atomic Stardust Tubing": "86.25",
  
//Northstar Hand Pulled Tubing
	"Amber Purple Tubing": "63.50",
	"Electric Blue Velvet Tubing": "72.50",
	"Ill-uminate Tubing": "158.50",
	"Mystery Aventurine Tubing": "63.50",
    "Serendipity Wonder Tubing": "72.50",
            "Serendipity Wonder Tubing-First": "72.50",
			"Serendipity Wonder Tubing-Odds": "49.95",
    "Star White Tubing": "63.50",
    "Yellow Tubing": "63.50",
    "Pomegranate Tubing": "68.00",
    "Green Money Wonder Tubing": "95.25",
    "Star White Tubing Odd": "54.50",
 	 "Lucy Tubing": "86.25",
  "Nemo Tubing": "90.00",
  "Coma Tubing": "90.00",
  
//Golden Gate Hand Pulled Tubing
	"Candy Corn Tubing": "86.25",
	"Duck Tubing": "81.50",
	"Fade to Fire Tubing": "81.50",
	"Fire/Water Purple Tubing": "77.00",
	"Fire/Water Tubing": "77.00",
	"Jail Bird Tubing": "77.00",
    "Fade to Jailbird Tubing": "77.00",
	"Kill Bill Tubing": "81.50",
	"Kiwi Pond Tubing": "81.50",
	"Magenta Dicro Tubing": "140.75",
	"Slyme TAG Tubing": "136.20",
    "Rainbow 1 On 1 Clear Tubing": "77.00",
    "Rainbow 2 Clear Tubing": "77.00",
    "Rainbow Tubing": "77.00",

//Grease Glass Tubing
	"Blue Cheese Tubing": "77.00",
	"Mighty Moss over Blue Cheese Tubing": "77.00",
	"Pink Cheese Tubing": "77.00",
	"Purple Rainbow Tubing": "77.00",
    "Globalt Tubing": "86.25",
    "CFL Purple Magenta Tubing": "68.00",
    "Hulk CFL Tubing": "149.85",
    "Shifty Peach Tubing": "99.85",
    "Shifty Peach Cheese Tubing": "99.85",
    "Shifty Peach Satin Tubing": "149.85",
    "Yoshi CFL Tubing": "122.50",

//Str8 Hand Pulled Tubing
  	"Blue Ghost Tubing": "77.00",
            "Blue Ghost Tubing-First": "77.00",
			"Blue Ghost Tubing-Seconds": "22.50",
			"Blue Ghost Tubing-Knuckles": "18.15",
  	"Illuminati Tubing": "118.00",
    "Purple Lollypop Tubing": "104.50",
    "PINK Slyme Tubing": "118.00",
    "Slyme Tubing": "104.50",
  
//Line Tubing
  	"Fade to Purple with Steel Wool": "77.00",
  	"Fade to Red": "77.00",
    "Rainbow 1 On 1 Clear Tubing": "77.00",
    "Rainbow Full Color Line Tubing": "77.00",
    "Rainbow 2 on 1 Clear Tubing": "77.00",
    "Rainbow Cane Rod": "77.00",
  	"Solo Cup Fade to Purple Line Tubing": "77.00",
    "Firey Sunset Line Tubing": "77.00",
    "Winter Mist Line Tubing": "77.00",
  "Triple Rainbow Cane": "77.00",
  "Spring Leaf Line Tubing": "77.00",
  "Jungle Line Tubing": "77.00",
  "Ocean Sunset Line Tubing": "77.00",
  "Fire & Ice Line Tubing": "77.00",
  "Jailbreak Line Tubing": "77.00",
  "Purple Fade to Teal Line Tubing": "77.00",
  "Black Fire Line Tubing": "77.00",
  "Pin Strike Line Tubing": "77.00",
  "Dirty Water Line Tubing": "77.00",
  "Four Elements Line Tubing": "77.00",
  "Blue Fire Line Tubing": "77.00",
  "Politics Line Tubing": "77.00",
  "Snowy Rainbow Line Tubing": "77.00",
  "Clear Rainbow Line Tubing": "77.00",
  "Clear Water Line Tubing": "77.00",
  "Gator Lake Line Tubing": "77.00",
  "Purple Rainbow Line Tubing": "77.00",
  "Black & Blue Line Tubing": "77.00",
  "White Water Line Tubing": "77.00",
  "Radioactive Rainbow Line Tubing": "118.00",
  "Electric Gator Line Tubing": "118.00",
  "Radioactive Water Line Tubing": "118.00",
  
//Float Glass: **************************************************************************** 
//Float Glass
    "Float Glass .150 Inch": "22.70",
    "Float Glass 3/8 Inch": "18.15",
    "Float Glass .629 Inch": "22.70",
    "Float Glass 40 MM  (1 1/2 Inch)": "22.70",
  
  
  
//************************************************************************************
//ENDING *****************************************************************************
  	"END": ""
};














function togglePrice( price, title){
  var pound = 454; //453.59237g = 1lb
  	var visiblePrice = prices[title];
    price.innerHTML = "$" + visiblePrice;
}